import script from "./ControllersPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ControllersPanel.vue?vue&type=script&setup=true&lang=ts"

import "./ControllersPanel.vue?vue&type=style&index=0&id=397d9e68&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-397d9e68"]])

export default __exports__